


//Funcion que hace que se mueva el ficho a la posicion en la que lo dejemos.
const reorder = (list, startIndex, endIndex, source, destination) => {
    const result = list;
    const [removed] = result[source].splice(startIndex, 1);
    result[destination].splice(endIndex, 0, removed);

    return result;
};


//Funcion que valida si ya se cumplio un turno para pasar al otro turno.
const validarTurno = (turnoActual) => {
    let result = 1;
    if(turnoActual === 1){
        result = 2;
    }else if(turnoActual === 2){
        result = 3;
    }else if(turnoActual === 3){
        result = 4;
    }else if(turnoActual === 4){
        result = 1;
    }

    return result;
};

//Esta funcion genera un letrero cada vez que se mueve un ficho a su lugar informando de que ficho sigue por jugar.
const letreroTurno = (turno, iniciarJuego) => {

    let result;
    if(turno === 1){
        result = "rojo";
    }else if(turno === 2){
        result = "verde";
    }else if(turno === 3){
        result = "amarillo";
    }else if(turno === 4 || iniciarJuego === true){
        result = "azul";
    }

    return `Es turno del ficho ${result}`;
}

//Funcion que valida la llegada a la casilla 50 sacando el valor exacto es decir,si esta en la casilla 49 debe sacar un 1 para llegar a la 50 igual que si esta en la casilla 48 debe sacar 2 para llegar a la casilla 50 etc.
const validarLlegada = (casillaActual, valorDado) => {
    let movimientoDeCasilla = false;
    let resultado;

    if(parseInt(casillaActual.slice(7)) === 50){
        movimientoDeCasilla = true;
    }else{
        if( parseInt(casillaActual.slice(7)) >= 44 && parseInt(casillaActual.slice(7)) <= 50 ){
            resultado = parseInt(casillaActual.slice(7)) + valorDado;
            if( resultado > 50 ){
                movimientoDeCasilla = true;
            }
        }
    }

    return movimientoDeCasilla;
}


const saltarNotificacionesCasilasEscalera = (casillaFinal) => {
    let result = false;
    if( casillaFinal === "casilla3" ||
    casillaFinal === "casilla5"  ||
    casillaFinal === "casilla6" ||
    casillaFinal === "casilla11" ||
    casillaFinal === "casilla12" ||
    casillaFinal === "casilla15" ||
    casillaFinal === "casilla16" ||
    casillaFinal === "casilla20" ||
    casillaFinal === "casilla23" ||
    casillaFinal === "casilla26" ||
    casillaFinal === "casilla21" ||
    casillaFinal === "casilla27" ||
    casillaFinal === "casilla29" ||
    casillaFinal === "casilla30" ||
    casillaFinal === "casilla34" ||
    casillaFinal === "casilla35" ||
    casillaFinal === "casilla36" ||
    casillaFinal === "casilla37" ||
    casillaFinal === "casilla41" ||
    casillaFinal === "casilla44" ||
    casillaFinal === "casilla45" ||
    casillaFinal === "casilla48"){
        result = true;
    }
    return result;
}


const saltarNotificacionesCasilasTobogan = (casillaFinal) => {
    let result = false;
    if( casillaFinal === "casilla18" || casillaFinal === "casilla25" || casillaFinal === "casilla31" || casillaFinal === "casilla39" || casillaFinal === "casilla46" || casillaFinal === "casilla49"){
        result = true;
    }
    return result;
}



//Funcion que determina si el jugador cae en una casilla escalera hacia que casilla sera encviado
const casillaDestinoEscalera = (casillaActual) => {
    let result;
    switch(casillaActual) {
        case "casilla5":
            result = "casilla22";
            break;
        case "casilla11":
            result = "casilla17";
            break;
        case "casilla15":
            result = "casilla32";
            break;
        case "casilla23":
            result = "casilla26";
            break;
        case "casilla27":
            result = "casilla38";
            break;
        case "casilla30":
            result = "casilla35";
            break;
        case "casilla37":
            result = "casilla40";
            break;

        default:
          // code block
    }
    return result;
}

//Funcion que determina si el jugador cae en una casilla escalera hacia que casilla sera encviado
const casillaDestinoTobogan = (casillaActual) => {
    let result;
    switch(casillaActual) {
        case "casilla25":
            result = "casilla2";
            break;
        case "casilla18":
            result = "casilla9";
            break;
        case "casilla31":
            result = "casilla19";
            break;
        case "casilla39":
            result = "casilla28";
            break;
        case "casilla46":
            result = "casilla33";
            break;
        case "casilla49":
            result = "casilla14";
            break;

        default:
          // code block
    }
    return result;
}




export { reorder, validarTurno, letreroTurno, validarLlegada, saltarNotificacionesCasilasEscalera, casillaDestinoEscalera, casillaDestinoTobogan, saltarNotificacionesCasilasTobogan };